var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({ref:"textareaInput",attrs:{"validate-on-blur":_vm.validateOnBlur,"outlined":_vm.outlined,"dense":_vm.dense,"autocomplete":"off","spellcheck":"false","no-resize":"","auto-grow":"","color":"black","background-color":"white"}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }